'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'LINK',
	name: 'Link',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Text',
	props: [{
		name: 'text',
		inputType: 'text',
		label: 'Text',
		default: 'Text..'
	}, {
		name: 'url',
		inputType: 'link',
		label: 'Link',
		default: '',
		requestKey: 'linkFriendlyName'
	}, {
		name: 'target',
		inputType: 'checkbox',
		label: 'Open in new tab/window',
		default: false
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};